import React, { useContext, useRef, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import _ from 'lodash';
import { getBestWeeksData } from 'gqlQueries/promoRecommendation';
import { bestWeeksDataParser } from 'parser/promoRecommendation';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';

const errorMessage: string = 'Something went wrong!';

function useFetchBestWeeksData() {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);
    const [count, setCount] = useState(0);
    const [data, setData] = useState<any>({
        bestWeeksMapping: null,
        weeksData: null,
    });
    const variablesRef = useRef<any>({});
    const { appConfig } = useContext(UserContext);
    const commonConfig = getConfig('commonConfig', appConfig);

    const [fetchBestWeeksData] = useLazyQuery(getBestWeeksData, {
        onCompleted: onFetchComplete,
        onError: onFetchError,
    });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const newData: any = {
                bestWeeksMapping: null,
                weeksData: null,
            };

            if (payload?.getBestWeeksData) {
                const { weeksPeriodsMappingData, bestWeeksData } = bestWeeksDataParser(payload?.getBestWeeksData);
                newData.bestWeeksMapping = weeksPeriodsMappingData;

                let tempData: any[] | null = null;
                //if not equal it means call coming from infinite scroll
                if (commonConfig.offset !== variablesRef.current.offset && Array.isArray(bestWeeksData)) {
                    tempData = [...data.weeksData, ...bestWeeksData];
                } else tempData = [...bestWeeksData];

                newData.weeksData = tempData;
            }
            setData(newData);
            setCount(payload?.getBestWeeksData?.totalCount || 0);
        } catch (error) {
            console.error(errorMessage, error);
            onFetchError(error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        //sending empty data to error to avoid null data being sent
        setLoading(false);
        setData(null);
        setError(error);
    }

    return {
        loading,
        error,
        data,
        count,
        fetchBestWeeksData: (variables: any) => {
            variablesRef.current = variables.variables;
            if (variables.variables.offset === commonConfig.offset) {
                setData(null);
                setCount(0);
            }
            setError(null);
            setLoading(true);
            fetchBestWeeksData(variables);
        },
    };
}

export { useFetchBestWeeksData };
